/** Page targets used by hero/info/header builder panels. */
export type PanelButtonNavigation =
  | 'homepage'
  | 'express-washes'
  | 'express-detail'
  | 'fleets'
  | 'coupons';

export const PANEL_BUTTON_NAVIGATION_OPTIONS: readonly {
  value: PanelButtonNavigation;
  label: string;
}[] = [
  { value: 'homepage', label: 'Homepage' },
  { value: 'express-washes', label: 'Express Washes' },
  { value: 'express-detail', label: 'Express Detail' },
  { value: 'fleets', label: 'Fleets' },
  { value: 'coupons', label: 'Coupons' }
];

const HASH_LINK_BY_NAVIGATION: Record<PanelButtonNavigation, string> = {
  homepage: '#home',
  'express-washes': '#express-wash-packages',
  'express-detail': '#express-auto-details',
  fleets: '#fleet-management',
  coupons: '#coupons'
};

const API_LINK_BY_NAVIGATION: Record<PanelButtonNavigation, string> = {
  homepage: '/',
  'express-washes': '/express-washes',
  'express-detail': '/express-details',
  fleets: '/fleets',
  coupons: '/coupons'
};

export function buttonNavigationToHashLink(navigation: PanelButtonNavigation): string {
  return HASH_LINK_BY_NAVIGATION[navigation] ?? HASH_LINK_BY_NAVIGATION['express-washes'];
}

export function buttonNavigationToApiLink(navigation: PanelButtonNavigation): string {
  return API_LINK_BY_NAVIGATION[navigation] ?? API_LINK_BY_NAVIGATION['express-washes'];
}

export function linkToButtonNavigation(link: string | undefined | null): PanelButtonNavigation {
  if (!link) {
    return 'express-washes';
  }

  const normalized = link.toLowerCase().trim().replace(/^#/, '').replace(/^\/+/, '');

  if (
    normalized === 'homepage' ||
    normalized === 'home' ||
    normalized === '' ||
    normalized.includes('booking')
  ) {
    return 'homepage';
  }

  if (
    normalized === 'express-washes' ||
    normalized.includes('express-wash') ||
    normalized.includes('expresswash')
  ) {
    return 'express-washes';
  }

  if (
    normalized === 'express-detail' ||
    normalized.includes('express-detail') ||
    normalized.includes('express-auto') ||
    normalized.includes('auto-detail')
  ) {
    return 'express-detail';
  }

  if (normalized === 'fleets' || normalized.includes('fleet')) {
    return 'fleets';
  }

  if (normalized === 'coupons' || normalized.includes('coupon')) {
    return 'coupons';
  }

  return 'express-washes';
}

export function isPanelButtonNavigation(value: string | undefined | null): value is PanelButtonNavigation {
  return PANEL_BUTTON_NAVIGATION_OPTIONS.some((option) => option.value === value);
}
